import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["options", "waiverReason"]
  static values = { optionsUrl: String }

  connect() {
    this.handleInputChange = this.scheduleMembershipLoad.bind(this)
    window.addEventListener("input:change", this.handleInputChange)

    const clientPicker = this.element.querySelector("#event_attendance_client")
    if (clientPicker) {
      this.clientPickerObserver = new MutationObserver(() => this.scheduleMembershipLoad())
      this.clientPickerObserver.observe(clientPicker, { childList: true, subtree: true })
    }
  }

  disconnect() {
    window.removeEventListener("input:change", this.handleInputChange)
    this.clientPickerObserver?.disconnect()
    window.clearTimeout(this.membershipLoadTimer)
    this.abortController?.abort()
  }

  scheduleMembershipLoad() {
    window.clearTimeout(this.membershipLoadTimer)
    this.membershipLoadTimer = window.setTimeout(() => this.loadForSelectedClient(), 0)
  }

  loadForSelectedClient() {
    const clientId = this.element.querySelector("input[name='event_attendance[client_id]']")?.value
    if (!clientId) {
      this.optionsTarget.innerHTML = ""
      return
    }

    this.abortController?.abort()
    this.abortController = new AbortController()
    const url = new URL(this.optionsUrlValue, window.location.origin)
    url.searchParams.set("client_id", clientId)

    fetch(url, { headers: { Accept: "text/html" }, signal: this.abortController.signal })
      .then(response => response.ok ? response.text() : Promise.reject(new Error("Unable to load memberships")))
      .then(html => { this.optionsTarget.innerHTML = html })
      .catch(error => {
        if (error.name !== "AbortError") this.optionsTarget.innerHTML = ""
      })
  }

  toggleWaiver(event) {
    if (!this.hasWaiverReasonTarget || event.target.name !== "event_attendance[membership_waived]") return

    this.waiverReasonTarget.classList.toggle("hidden", !event.target.checked)
  }
}
